import React from "react";

const MobileContactBanner = () => {
  return (
    <div id="contact-us-banner-container">
      <div id="contact-us-banner-innercontainer">
        <div id="contact-title">
          <div className="text-center" style={{ paddingBottom: "4rem" }}>
            Get In Touch
          </div>
        </div>
        <div id="contact-desc-container">
          {/* Description */}
          <h3 id="contact-desc" className="text-center text-white">
            Let’s Build Something Extraordinary Together
          </h3>
          <h6 id="contact-next-desc" className="text-center text-white">
            Whether You’re Exploring Startup Ideas, Tackling Challenges, Or
            Scaling Your Business, We’re Here To Help.
          </h6>
        </div>
        <div
          id="contact-service"
          className={`text-white d-flex justify-content-around align-items-center mb-3`}
        >
          {/* Service Section */}
          <div style={{ width: "40%" }}>
            <h2 id="contact-desc-left" className="text-center">
              How We <br /> Can Help?
            </h2>
          </div>
          <div
            style={{
              width: "55%",
              paddingLeft: "7rem",
              borderLeft: "1px solid white",
              marginTop: "2rem",
              marginBottom: "2rem",
            }}
            id="contact-desc-right"
          >
            <div>
              <b style={{ fontSize: "1rem", textAlign: "center !important" }}>
                We Offer Tailored Support Across All Stages Of The Startup
                Lifecycle
              </b>
            </div>
            <div className="mt-2">
              <div>
                <b>Idea Stage:</b>
              </div>
              <div>
                Validate your concept with data-driven insights. Build a
                business model and MVP roadmap.
              </div>
            </div>
            <div className="mt-2">
              <div>
                <b>Valley Of Death Stage:</b>
              </div>
              <div>
                Navigate funding and operational challenges. Develop strategies
                to sustain and grow.
              </div>
            </div>
            <div className="mt-2">
              <div>
                <b>Growth Stage:</b>
              </div>
              <div>
                Scale confidently with optimized processes. Unlock growth
                opportunities and prepare for expansion. 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileContactBanner;
